<template>
  <div class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h4 v-text="$t('status')" class="mb-3" />
        <div class="vx-row">
          <div v-for="(status, key) in exportFilter.statuses" v-bind:key="'status_' + key" class="mb-3 vx-col sm:w-1/3 md:w-1/3 w-full">
            <vs-checkbox :value="status.value" v-model="status.selected">{{ $t(`auto_call_system_${status.value.toLowerCase().replace(' ', '_')}`) }}</vs-checkbox>
          </div>
        </div>
        <div class="mb-3">
          <div class="vx-col w-full">
            <label class="vs-input--label" v-text="$t('date_filter_from')" />
            <date-picker v-model="exportFilter.dateFrom" :model="exportFilter.dateFrom" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
          </div>
        </div>
        <div class="mb-3">
          <div class="vx-col w-full">
            <label class="vs-input--label" v-text="$t('date_filter_to')" />
            <date-picker v-model="exportFilter.dateTo" :model="exportFilter.dateTo" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventBus } from '@/../eventbus.js'
import DatePicker from '@/components/form-inputs/DatePicker'
import AutoCallSystemPublic from '@/models/AutoCallSystemPublic'

export default {
  name: 'Shared.AutoCallSystemPublic.ExportData',
  components: {
    DatePicker
  },
  data () {
    return {
      exportFilter: {
        dateFrom: this.$momentHelper.getCurrentDate(),
        dateTo: this.$momentHelper.getCurrentDate(),
        statuses: []
      },
      companyId: this.$store.getters.userInfo.company.id,
      userId: this.$store.getters.userInfo.id
    }
  },
  mounted () {
    EventBus.$on('initExportAutoCallSystemPublicData', this.exportData)
    EventBus.$on('initReUploadAutoCallSystemPublicData', this.reUploadData)
    this.loadSettings()
  },
  methods: {
    async loadSettings () {
      const response = await AutoCallSystemPublic.getCurrentStatus()
      this.exportFilter.statuses = response.data
    },
    async exportData () {
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        const status = []
        this.exportFilter.statuses.forEach(function (data) {
          if (data.selected === true) {
            status.push(data.value)
          }
        })
        await AutoCallSystemPublic.exportAutoCallSystemData(this.companyId, this.userId, language, {dateFrom: this.exportFilter.dateFrom, dateTo: this.exportFilter.dateTo, statuses: status.join(',')})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    async reUploadData () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#reUploadButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const status = []
          this.exportFilter.statuses.forEach(function (data) {
            if (data.selected === true) {
              status.push(data.value)
            }
          })

          const response = await AutoCallSystemPublic.reUploadData({dateFrom: this.exportFilter.dateFrom, dateTo: this.exportFilter.dateTo, statuses: status.join(',')})

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.$emit('reUploadSuccess')

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.formErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#reUploadButton > .con-vs-loading')

      // try {
      //   const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      //   const status = []
      //   this.exportFilter.statuses.forEach(function (data) {
      //     if (data.selected === true) {
      //       status.push(data.value)
      //     }
      //   })
      //   await AutoCallSystemPublic.exportAutoCallSystemData(this.companyId, this.userId, language, {dateFrom: this.exportFilter.dateFrom, dateTo: this.exportFilter.dateTo, statuses: status.join(',')})
      // } catch (e) {
      //   this.$alertHelper.error()
      // }
    }
  }
}
</script>

<style lang="scss">
#exportButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
